import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ProfilesService } from 'src/app/_services/new-settings/profiles.service';
import { ChangePasswordComponent } from 'src/app/user/change-password/change-password.component';
import { EditProfileComponent } from 'src/app/user/edit-profile/edit-profile.component';

@Component({
    selector: 'app-profiles',
    templateUrl: './profiles.component.html',
    styleUrls: ['./profiles.component.scss'],
    standalone: false
})
export class ProfilesComponent implements OnInit {

  ProfileDetails: any;
  successMessage: string;
  errorMessage: string;
  currentPlanDetails: any;


  constructor(
    private modalService: NgbModal,
    private profilesService: ProfilesService,
    private localstorageservice: LocalStorageService
  ) { }

  ngOnInit() {
    this.getuserDetails();
    this.getCurrentPlanDetails();
  };



  /**
   * Fetch Current Plan Details
   */
  getCurrentPlanDetails() {
    const userNumber = this.localstorageservice.getItem('usernumber');
    this.profilesService.fetchcurrentplandetails(userNumber).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.currentPlanDetails = res.data;
      } else {
        this.currentPlanDetails = {};
      }
    });
  }

  /**
   * Fetch User Details
   */
  getuserDetails() {
    const userNumber = this.localstorageservice.getItem('usernumber');
    this.profilesService.fetchUserDetails(userNumber).subscribe((res: any) => {
      if (res.status == 'success') {
        this.ProfileDetails = res.data
      }
    })
  };

  /**
   * Edit User Details
   */
  EditProfileDetails() {
    const modalRef = this.modalService.open(EditProfileComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });

    modalRef.componentInstance.backupProfileobj = this.ProfileDetails;
    modalRef.componentInstance.passEntry.subscribe((x: any) => {
      if (x == 'success') {
        this.successMessage = "Details Saved Succesfully";
        setTimeout(() => this.successMessage = '', 5000);
        this.getuserDetails();
      } else if (x == 'error') {
        this.errorMessage = "Something went Wrong";
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  /**
   * Reset User Password
   */
  changepasswordmodal() {
    const modalRef = this.modalService.open(ChangePasswordComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.ProfileDetails = this.ProfileDetails;
    modalRef.componentInstance.passEntry.subscribe((x: any) => {
      if (x == 'success') {
        this.successMessage = "Details Saved Succesfully";
        setTimeout(() => this.successMessage = '', 5000);
        this.getuserDetails();
      } else if (x == 'error') {
        this.errorMessage = "Something went Wrong";
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }
}
